import { bool, node } from "prop-types";
import { useEffect, useState, useRef } from "react";

import Header from "../../components/Header";
import BackButton from "../../components/BackButton";
import PageLogo from "../../components/PageLogo";
import Footer from "../../components/Footer";
import { Box } from "@mui/material";
import { useParams } from "react-router-dom";
import useSWR from "swr";
import { fetcher } from "../../utils/fetcher";

const PageLayout = ({children, showLogo=true, }) => {
    const [isSticky, setIsSticky] = useState(false);
    const [isVisible, setIsVisible] = useState(true);
    const lastScrollY = useRef(0);
    const params = useParams();
    const retailerId = params?.retailerId;

    const retailerFieldsToFetch = [
        'logo',
    ];

    const { data: retailerSettings } = useSWR(retailerId ? { url: `/retailer/${retailerId}`, fields: retailerFieldsToFetch } : null, fetcher);
    
    useEffect(() => {
        const handleScroll = () => {
            const currentScrollY = window.scrollY;
            const isScrollingDown = currentScrollY > lastScrollY.current;
            
            // Show sticky nav when scroll position is above threshold
            if (currentScrollY > 10) {
                setIsSticky(true);
                
                // Hide when scrolling down, show when scrolling up
                if (isScrollingDown) {
                    setIsVisible(false);
                } else {
                    setIsVisible(true);
                }
            } else {
                setIsSticky(false);
                setIsVisible(true);
            }
            
            lastScrollY.current = currentScrollY;
        };
        
        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    return (
        <>
            <Box
                sx={{
                    minHeight: 'calc(100vh - 320px)',
                }}
            >
                <Box
                    sx={{
                        position: isSticky ? 'sticky' : 'relative',
                        top: 0,
                        zIndex: 1000,
                        transform: isSticky && !isVisible ? 'translateY(-100%)' : 'translateY(0)',
                        transition: 'transform 0.3s ease-in-out',
                    }}
                >
                    <Header />
                    <BackButton />
                </Box>
                {showLogo && <PageLogo logoOverrideId={retailerSettings?.logo} />}
                {children}
            </Box>
            <Footer />
        </>
    )
}

PageLayout.propTypes = {
    children: node.isRequired,
    showLogo: bool
}

export default PageLayout;